document.querySelectorAll('.Index_meet_visible_result_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        /* Preload the neighbouring slides so the panel you advance to is already
           there rather than loading in under you. */
        lazyPreloadPrevNext: 2,
        loop: true,
        grabCursor: true,
        spaceBetween: 0,
        slidesPerGroup: 1,
        slidesPerView: 1,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        /* One slide is the whole panel, 598px wide on a phone, so at Swiper's
           default longSwipesRatio of 0.5 a drag had to cover 299px before it
           would advance. That is most of the screen, so a gentle swipe always
           sprang back and the panel read as not draggable at all. A fifth of a
           panel registers, which is about 120px. allowTouchMove is already on
           by default, the ratio was the thing stopping the gesture. */
        longSwipesRatio: 0.2,
        mousewheel: {
            forceToAxis: !0
        },
        /* Fade, not slide. Every slide is the same two circles in the same place,
           so translating the whole composition out and a duplicate back in read
           as the panel reloading rather than advancing. Fade leaves every slide
           at translate3d(0,0,0) so the frame never moves, and the stylesheet pins
           .swiper-slide opaque so the white round never goes translucent on the
           way through. The dissolve is on the per product content only. */
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        /* Matches the .6s content dissolve in the stylesheet. Deliberately
           slower than the 300ms on the results carousel further down the page,
           so this panel changes gently instead of snapping. */
        speed: 600,
        autoplay: {
            /* Four products, 7s each, so a full pass takes about 31s. Long
               enough to read the figure and its caption before it moves.
               disableOnInteraction:false means clicking a dot or dragging does
               not kill the cycle for good, and it pauses under the cursor so it
               never moves while someone is reading. */
            delay: 7000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            /* Autoplay pauses itself the moment a slide starts moving and, by
               default, waits for a native transitionend on the track before it
               re-arms its timer. Fade parks every slide at translate3d(0,0,0), so
               the track's transform never animates and that event never fires.
               Autoplay advanced once and then sat paused for good. Not waiting for
               it puts the re-arm back on the plain timer, which is all this panel
               needs since the dissolve is on the inner content, not the track. */
            waitForTransition: false,
        },
        observer: true,
        observeParents: true,
        /* Scoped to this slider. A bare ".swiper-pagination" selector resolves
           document-wide and returns the first match, so on a page with more than
           one carousel this section can drive, or be driven by, the wrong dots. */
        pagination: {
          el: el.querySelector(".swiper-pagination"),
          clickable: true,
        },
        on: {
          /* Swiper only clears its animating flag when a transitionend reaches
             it. Fade parks every slide at translate3d(0,0,0) so the track's
             transform never animates, and the stylesheet pins .swiper-slide
             opaque so the slide's own opacity never animates either, which
             leaves nothing to raise that event. The flag then latched on for
             good, and with loop on that makes slideNext refuse to run at all.
             Close the transition by hand once the speed has elapsed. Dragging
             and the dots were never affected because they call slideTo directly. */
          transitionStart: function () {
            const sw = this;
            clearTimeout(sw.mvrCloseTransition);
            sw.mvrCloseTransition = setTimeout(function () {
              if (sw && !sw.destroyed && sw.animating) sw.transitionEnd();
            }, sw.params.speed + 50);
          }
        }
    })
  }
});